// TODO recheck all

export const HOST_URL = `https://${process.env.REACT_APP_HOSTNAME}`;
export const FE_HOST = `https://${process.env.REACT_APP_FE_HOST}`;
export const AUTH_URL = `https://${process.env.REACT_APP_AUTH_URL}`;
export const MODEL_MANAGER_URL = `https://${process.env.REACT_APP_MODEL_MANAGER_URL}`;
export const MODEL_MANAGER_FRONT_URL = `https://${process.env.REACT_APP_MODEL_MANAGER_FRONTEND_URL}`;
export const NOTIFICATION_SERVICE =
  process.env.REACT_APP_NOTIFICATION_SERVICE_URL;
export const AWS_BUCKET_URL = `https://${process.env.REACT_APP_AWS_BUCKET_URL}`;
export const STRIPE_KEY = process.env.STRIPE_KEY;
export const DEMO_VIDEO_ID = process.env.REACT_APP_DEMO_ID;
export const GOOGLE_RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_KEY;
export const SENTRY_DSN = `https://${process.env.REACT_APP_SENTRY_DSN}`;
export const SENTRY_TRACES_SAMPLE_RATE = parseFloat(
  process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || "1.0"
);
export const MIN_DURATION = 0.1; // sec
export const MAX_SHORT_DURATION = 30; // sec
export const MAX_LONG_DURATION = 3600; // sec
export const MAX_FILE_SIZE = 1024 * 1024 * 1024; // 1024 Mb
export const MAX_FILES_COUNT = parseInt(process.env.REACT_APP_MAX_FILES_COUNT);
export const NOTIFICATION_TIMEOUT = 5000;
export const CACHE_TIMEOUT = 3 * 60 * 1000; // 3 min
export const SEC_IN_ONE_DAY = 24 * 60 * 60 * 1000;
export const MONTH_LIMIT_STANDARD_PLAN = 120;
export const MONTH_LIMIT_PRO_PLAN = 600;
export const GMT_TIME_IDENTIFIER = "+00:00";
export const DEFAULT_DATE_FORMAT = "dd MMM yyyy"; // sticked to date-fns format
export const DEFAULT_DATE_PICKER_FORMAT = "dd/MM/yyyy"; // sticked to date-fns format
export const DEFAULT_DATETIME_FORMAT = "dd MMM yyyy HH:mm:ss"; // sticked to date-fns format
export const EMAIL_REGEX =
  /^\s*(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/;
export const FIRST_LAST_NAME_REGEX = /^\s*(?=.{2,20}\s*$)[a-zA-Z-']+\s*$/;
export const PASSWORD_REGEX = /^\s*(?!^ +$)(?=.{8,32}$)^.+$/;
export const INCLUDES_DIGITS_REGEX = /.*[0-9].*/;
export const INCLUDES_UPPERCASE_REGEX = /.*[A-Z].*/;
export const INCLUDES_LOWERCASE_REGEX = /.*[a-z].*/;
export const INCLUDES_SPECIAL_CHARS_REGEX =
  /.*[!@#$%^&*()_+{}[\]:;<>,.?~\\/-].*/;
export const PROMO_CODE_REGEX = /(?!^ +$)(?=.{2,32}$)^.+$/;
export const MIC_ON_UPLOAD = "file";
export const MIC_ON_TTS = "tts";
export const PAGINATION = {
  projects: parseInt(process.env.REACT_APP_PROJECTS_PER_PAGE),
  folders: parseInt(process.env.REACT_APP_FOLDERS_PER_PAGE),
  calibrations: parseInt(process.env.REACT_APP_CALIBRATIONS_PER_PAGE),
  recordings: parseInt(process.env.REACT_APP_RECORDINGS_PER_PAGE),
  conversions: parseInt(process.env.REACT_APP_CONVERSIONS_PER_PAGE),
  users: parseInt(process.env.REACT_APP_CONVERSIONS_PER_PAGE),
  voices: parseInt(process.env.REACT_APP_VOICES_PER_PAGE),
};
export const TTS_PAID = process.env.REACT_APP_TTS_PAID;
export const TTS_TRIAL = process.env.REACT_APP_TTS_TRIAL;

export const FOLDER_PAGINATION_SEARCH = 10;

export const PER_PAGE_VALUES = {
  projects: [20, PAGINATION.projects, 100],
  recordings: [20, PAGINATION.recordings, 100],
  conversions: [20, PAGINATION.conversions, 100],
  calibrations: [20, PAGINATION.calibrations, 100],
};

export const LOCALSTORAGE_ITEMS = {
  perPage: {
    projects: "pagination_per_page",
  },
  sort: {
    projects: {
      key: "pagination_sort_projects_key",
      direction: "pagination_sort_projects_direction",
    },
    recordings: {
      key: "pagination_sort_recordings_key",
      direction: "pagination_sort_recordings_direction",
    },
    folders: {
      key: "pagination_sort_folders_key",
      direction: "pagination_sort_folders_direction",
    },
  },
  microphone: {
    id: "microphone_id",
    name: "microphone_name",
  },
  recorder: {
    tab: "recorder_tab",
  },
  tips: {
    calibration: "tips_calibration",
    audioSettingsIntro: "audioSettingsIntro",
  },
  filters: {
    voices: {
      type: "type",
      age: "age",
      gender: "gender",
      pitch: "pitch",
      nationality: "nationality",
      narrationStyle: "narrationStyle",
      category: "category",
    },
    projects: {
      state: "state",
    },
  },
  preselectedVoiceId: "preselectedVoiceId",
  lastUsedVoices: "lastUsedVoices",
  newOriginalData: "newOriginalData",
  hideRecordingTips: "hideRecordingTips",
  promo: "promo",
};

export const PRESELECTED_VOICE_PARAM = "preselectedVoiceId";

export const ONE_HOUR = 1000 * 60 * 60;

export const recorderDefaultConfig = {
  bufferLength: 4096,
  encoderApplication: 2049,
  encoderFrameSize: 20,
  encoderPath: "/opus-recorder/waveWorker.min.js",
  encoderSampleRate: 48000,
  encoderBitRate: 196000,
  maxFramesPerPage: 40,
  mediaTrackConstraints: {
    autoGainControl: false,
    echoCancellation: false,
    noiseSuppression: false,
    deviceId: null,
  },
  monitorGain: 0,
  numberOfChannels: 1,
  recordingGain: 1,
  resampleQuality: 3,
  streamPages: false,
  reuseWorker: false,
  wavBitDepth: 16,
};

export const RECORDING_STATE = {
  DONE: "done",
  PROCESSING: "processing",
  POSTPROCESSING: "postprocessing",
  ERROR: "error",
};

export const RECORDING_TYPES = {
  ORIGINAL: "original",
  CONVERTED: "converted",
};

export const PARAM_WIDGETS = {
  SLIDER: "slider",
  DROPDOWN: "dropdown",
};

export const PROJECT_SETTINGS_PITCH_CORRECTION = "pitch_correction";
export const PROJECT_SETTINGS_SEMITONES_CORRECTION = "semitones_correction";
export const PITCH_STEP = 0.5;

export const USER_ROLES = {
  USER: "user",
  PREPAID: "prepaid",
  ADMIN: "admin",
};

export const EMAIL_VERIFICATION_STATUS = {
  SUCCESS: "success",
  FAIL: "fail",
};

export const SUBSCRIPTION_STATUS = {
  NULL: "null",
  TRIALING: "trialing",
  INCOMPLETE: "incomplete",
  ACTIVE: "active",
  UNPAID: "unpaid",
};

export const CALIBRATION_STATE = {
  PROCESSING: "processing",
  CALIBRATED: "calibrated",
  ERROR: "error",
};

export const MODEL_VISIBILITY = {
  public: "public",
  paid: "paid",
  private: "private",
  kids: "kids",
};

export const MODEL_GROUP_KEYS = {
  public: "public",
  private: "private",
};

export const PASSWORD_UPDATE_STATUS = {
  SUCCESS: "success",
  FAIL: "fail",
};

export const JIRA_ISSUE_CONNECTOR_EMAIL_KEY = "_ce";
export const JIRA_ISSUE_CONNECTOR_FIRST_LAST_NAME_KEY = "_cfl";

export const MAX_AVAILABLE_SELECTED_MODELS = 5;

export const PITCH_SEMITONES_VALUE = 8;

export const CSRF_TOKEN_HEADER_KEY = "x-csrf-token";
export const CSRF_TOKEN_KEY = "_ct";

export const DOWNLOAD_MESSAGE_SHOW_TIME_KEY = "downloadMessageShowTime";

export const TTS_SAMPLE_TEXT =
  "This is a sample text provided for demonstration purposes. Feel free to modify or replace it with your own content. They say our text-to-speech models sound amazingly natural!";

export const DEFAULT_NAME_PATTERN =
  /^(?=\s*.{1,40}\s*$)(?!\s*-{2,})(?=.*(\d|\w))[[\].,()a-zA-Z0-9-\s]*$/;
export const DEFAULT_NAME_PATTERN_ERROR_MESSAGE =
  "Must contain only latin letters, numbers, parenthesis, square brackets, dots or commas, length should be between 1 and 40 characters";
export const MODERATION_ERROR_MESSAGE =
  "Oops! Your content doesn’t meet our moderation guidelines.";

export const CHARACTERS_LIMIT = {
  PROJECT_NAME: DEFAULT_NAME_PATTERN,
  FOLDER_NAME: DEFAULT_NAME_PATTERN,
  RECORDING_NAME: DEFAULT_NAME_PATTERN,
  CALIBRATION_NAME: DEFAULT_NAME_PATTERN,
};

export const MOBILE_WIDTH = 768;

export const T_LEVEL = {
  gray: "gray",
  red: "red",
  orange: "orange",
  green: "green",
};

export const T_LEVEL_COLORS_MAPPING = {
  [T_LEVEL.gray]: {
    color: "disabled",
    text: "Default",
  },
  [T_LEVEL.red]: {
    color: "error",
    text: "Needs to be checked",
  },
  [T_LEVEL.orange]: {
    color: "warning",
    text: "Should be checked sometime",
  },
  [T_LEVEL.green]: {
    color: "success",
    text: "Approved",
  },
};

export const SORT_DIRECTION = {
  asc: "asc",
  desc: "desc",
};

export const PROJECTS_SORT_KEYS = {
  UPDATED_AT_DESC: {
    label: "Date Updated",
    ariaLabel: "Date Updated",
    key: "last_recording_at",
    direction: SORT_DIRECTION.desc,
  },
  CREATED_AT_DESC: {
    label: "Date Created",
    ariaLabel: "Date Created",
    key: "created_at",
    direction: SORT_DIRECTION.desc,
  },
  NAME_ASC: {
    label: "Name A-Z",
    ariaLabel: "Name Ascending",
    key: "name",
    direction: SORT_DIRECTION.asc,
  },
  NAME_DESC: {
    label: "Name Z-A",
    ariaLabel: "Name Descending",
    key: "name",
    direction: SORT_DIRECTION.desc,
  },
};

export const RECORDINGS_SORT_KEYS = {
  UPDATED_AT_DESC: {
    label: "Date Updated",
    ariaLabel: "Date Updated",
    key: "last_recording_at",
    direction: SORT_DIRECTION.desc,
  },
  CREATED_AT_DESC: {
    label: "Date Created",
    ariaLabel: "Date Created",
    key: "created_at",
    direction: SORT_DIRECTION.desc,
  },
  NAME_ASC: {
    label: "Name A-Z",
    ariaLabel: "Name Ascending",
    key: "label",
    direction: SORT_DIRECTION.asc,
  },
  NAME_DESC: {
    label: "Name Z-A",
    ariaLabel: "Name Descending",
    key: "label",
    direction: SORT_DIRECTION.desc,
  },
};

export const FOLDERS_SORT_KEYS = {
  UPDATED_AT_DESC: {
    label: "Date Updated",
    ariaLabel: "Date Updated",
    key: "updated_at",
    direction: SORT_DIRECTION.desc,
  },
  CREATED_AT_DESC: {
    label: "Date Created",
    ariaLabel: "Date Created",
    key: "created_at",
    direction: SORT_DIRECTION.desc,
  },
  NAME_ASC: {
    label: "Name A-Z",
    ariaLabel: "Name Ascending",
    key: "name",
    direction: SORT_DIRECTION.asc,
  },
  NAME_DESC: {
    label: "Name Z-A",
    ariaLabel: "Name Descending",
    key: "name",
    direction: SORT_DIRECTION.desc,
  },
};

export const VOICES_SORT_KEYS = {
  DEFAULT: {
    label: "Default",
    ariaLabel: "Default",
    key: "default",
    direction: SORT_DIRECTION.desc,
  },
  CREATED_AT_DESC: {
    label: "Newest First",
    ariaLabel: "Newest First",
    key: "created_at",
    direction: SORT_DIRECTION.desc,
  },
  PITCH_ASC: {
    label: "Pitch: Low First",
    ariaLabel: "Pitch: Low First",
    key: "pitch",
    direction: SORT_DIRECTION.asc,
  },
  PITCH_DESC: {
    label: "Pitch: High First",
    ariaLabel: "Pitch: High First",
    key: "pitch",
    direction: SORT_DIRECTION.desc,
  },
};

const basePaginationData = {
  pagination: {
    currentPage: 1,
    totalPages: 1,
    count: 0, // total records
    limit: 1,
    offset: 0,
    forceFetch: false,
  },
};

// TODO refactor this
export const initialProjectListPaginationParams = {
  ...basePaginationData,
  pagination: {
    ...basePaginationData.pagination,
    limit: PAGINATION.projects,
  },
  filters: {
    owner: null,
  },
};

export const initialFolderListPaginationParams = {
  ...basePaginationData,
  pagination: {
    ...basePaginationData.pagination,
    limit: PAGINATION.folders,
  },
};

export const initialCalibrationListPaginationParams = {
  ...basePaginationData,
  pagination: {
    ...basePaginationData.pagination,
    limit: PAGINATION.calibrations,
  },
};

export const initialRecordingListPaginationParams = {
  ...basePaginationData,
  pagination: {
    ...basePaginationData.pagination,
    limit: PAGINATION.recordings,
  },
};

export const initialConversionListPaginationParams = {
  ...basePaginationData,
  pagination: {
    ...basePaginationData.pagination,
    limit: PAGINATION.conversions,
  },
};

export const initialVoiceListPaginationParams = {
  ...basePaginationData,
  pagination: {
    ...basePaginationData.pagination,
    limit: PAGINATION.voices,
  },
};

export const USERS_STATS_SORT_OPTIONS = {
  total_converted_duration: "total_converted_duration",
  total_conversions: "total_conversions",
  completed_conversions: "completed_conversions",
  in_progress_conversions: "in_progress_conversions",
  failed_conversions: "failed_conversions",
  converted_duration_this_month: "converted_duration_this_month",
};

export const initialUsersStatsPaginationParams = {
  ...basePaginationData,
  pagination: {
    ...basePaginationData.pagination,
    limit: PAGINATION.users,
    sort: USERS_STATS_SORT_OPTIONS.total_converted_duration,
    direction: SORT_DIRECTION.desc,
    ownerIds: [],
  },
};

export const CONVERSIONS_STATUS = {
  ERROR: "failed",
  PROCESSING: "in_progress",
  DONE: "completed",
  NONE: "none",
};

export const RECORDING_STATE_TO_CONVERSION_STATUS = {
  [RECORDING_STATE.DONE]: CONVERSIONS_STATUS.DONE,
  [RECORDING_STATE.PROCESSING]: CONVERSIONS_STATUS.PROCESSING,
  [RECORDING_STATE.ERROR]: CONVERSIONS_STATUS.ERROR,
};

export const defaultFolderStats = {
  completed: 0,
  failed: 0,
  in_progress: 0,
  total: 0,
};

export const ROOT_FOLDER_ID = "root";

export const STRIPE_SUBSCRIPTION_TYPES = {
  year: "year",
  month: "month",
  monthPro: "month_pro",
  yearPro: "year_pro",
  credits: "credits",
};

export const STRIPE_SUBSCRIPTION_INTERVALS = {
  year: "year",
  month: "month",
  custom: "custom",
  credits: "credits",
};

export const SUBSCRIPTION_LABELS = {
  explorer: "Explorer",
  creator: "Creator",
  power: "Power",
  standard: "Standard (Outdated)", // remove
  pro: "Pro", // remove
  tts: "TTS Only",
  custom: "Custom",
  trial: "Free Trial",
  trialExpired: "Free Trial Expired",
  perMinutes: "Per Minute",
  perCredits: "Pay As You Go",
};

export const SUBSCRIPTIONS = {
  trial: {
    requirePayment: false,
    label: "Trial",
  },
  custom: {
    requirePayment: false,
    label: "Custom",
  },
  perMinutes: {
    requirePayment: true,
    label: "Per Minute",
  },
  perCredits: {
    requirePayment: true,
    label: "Per Credits",
    intervals: {
      "5min": "credits_5min",
      "16min": "credits_16min",
      "30min": "credits_30min",
      "100min": "credits_100min",
      "500min": "credits_500min",
    },
  },
  explorer: {
    requirePayment: true,
    label: "Explorer",
    intervals: {
      [STRIPE_SUBSCRIPTION_INTERVALS.month]: "explorer_monthly",
      [STRIPE_SUBSCRIPTION_INTERVALS.year]: "explorer_yearly",
    },
  },
  creator: {
    requirePayment: true,
    label: "Creator",
    intervals: {
      [STRIPE_SUBSCRIPTION_INTERVALS.month]: "creator_monthly",
      [STRIPE_SUBSCRIPTION_INTERVALS.year]: "creator_yearly",
    },
  },
  power: {
    requirePayment: true,
    label: "Power",
    intervals: {
      [STRIPE_SUBSCRIPTION_INTERVALS.month]: "power_monthly",
      [STRIPE_SUBSCRIPTION_INTERVALS.year]: "power_yearly",
    },
  },
  tts: {
    requirePayment: true,
    label: "TTS Only",
    intervals: {
      [STRIPE_SUBSCRIPTION_INTERVALS.month]: {
        "30k": "tts_30k_monthly",
        "100k": "tts_100k_monthly",
        "500k": "tts_500k_monthly",
        "2m": "tts_2m_monthly",
        "10m": "tts_10m_monthly",
      },
      [STRIPE_SUBSCRIPTION_INTERVALS.year]: {
        "30k": "tts_30k_yearly",
        "100k": "tts_100k_yearly",
        "500k": "tts_500k_yearly",
        "2m": "tts_2m_yearly",
        "10m": "tts_10m_yearly",
      },
    },
  },
};

export const STRIPE_COUPON_TYPE = {
  month: "month",
  year: "year",
};

export const STRIPE_COUPON_AMOUNT_TYPE = {
  amount: "amount",
  percent: "percent",
};

export const STRIPE_SUBSCRIPTION_CATEGORIES = {
  tts_only: "tts_only",
};

export const LINKS = {
  home: "/",
  login: "/login",
  signup: "/signup",
  mobileLogin: "/login/mobile",
  loginRedirect: "/auth-redirect",
  oauth2: "/oauth2",
  loginFromRedirect: "/login-redirect",
  projects: "/projects",
  faq: "/faq",
  pricing: "/pricing",
  account: "/account",
  plan: "/account/plan",
  statistics: "/account/statistics",
  calibrations: "/calibrations",
  createCalibration: "/calibrations/create",
  auditionVoices: "/audition-voices",
  chooseVoices: "/choose-voices",
  voiceTalents: "/voice-talents",
  useCases: "/use-cases",
  forgotPassword: "/forgot-password",
  forgotPasswordEmailSent: "/forgot-password-email-sent",
  changePasswordSuccess: "/change-password-success",
  termsOfUse: "/terms-of-use",
  acceptableUsePolicy: "/aup",
  helpVideo: "/help-video",
  subscribed: "/subscribed",
  unverified: "/unverified",
  verifyEmail: "/verify/email",
  users: "/users",
  createRecording: "/new",
  requestACall: "https://www.respeecher.com/request-a-call",
  contactUs: "https://www.respeecher.com/contact-us",
  marketplaceContactUs: "https://www.respeecher.com/marketplace-contact",
  respeecher: "https://www.respeecher.com",
  respeecherForBusiness:
    "https://www.respeecher.com/?utm_source=direct&utm_medium=business_cta&utm_campaign=marketplace",
  welcomeWizard: "/welcome",
  audioSettings: "/audio-settings",
};

export const PRICING_DATA = {
  trial: {
    title: "Free Trial",
    price: "Try free for 3 days",
    features: [
      "100+ voices",
      "Credit card not required",
      "Download not available",
    ],
    eligibility: "Commercial usage not allowed",
  },
  standard: {
    title: "Standard",
    price: "$199 monthly /\n$1999 yearly",
    features: [
      "100+ voices",
      "120 minutes of conversions",
      "$0.09 per extra second",
    ],
    eligibility: "Eligible if revenue <$1M last year",
  },
  pro: {
    title: "Pro",
    price: "$499 monthly /\n$4999 yearly",
    features: [
      "100+ voices",
      "600 minutes of conversions",
      "$0.09 per extra second",
    ],
    eligibility: "Eligible if revenue <$1M last year",
  },
  custom: {
    title: "Custom",
    price: "Let‘s Chat",
    features: ["Custom voices", "API access", "Real-time conversions"],
  },
  perMinute: {
    title: "Per Minute",
    price: "$0.09 /second",
    features: ["100+ voices", "Metered usage", "Minimum purchase: $29"],
    eligibility: "Eligible if revenue <$1M last year",
  },
};

export const calibrationTips = [
  {
    id: 1,
    label: "Tip 1",
    text: "Find a quiet place & Use a good mic",
    image: "/images/tip-1.png",
  },
  {
    id: 2,
    label: "Tip 2",
    text: "Record 30 seconds",
    image: "/images/tip-2.png",
  },
  {
    id: 3,
    label: "Tip 3",
    text: "Talk about anything or use our sample text",
    image: "/images/tip-3.png",
  },
];

export const DISABLED_FOR_TRIAL_MESSAGE = "Available only for paid users";

export const LOU_KEY = "_lou";
export const LOU_TOURS = {
  calibrationComplete: "calibrationComplete",
  originalCreate: "originalCreate",
  conversionCreate: "conversionCreate",
  startTour: "startTour",
  newProject: "newProject",
};

export const IS_DEV_ENV = process.env.NODE_ENV === "development";

export const IS_SENTRY_AVAILABLE =
  process.env.REACT_APP_SENTRY_DSN &&
  process.env.REACT_APP_SENTRY_DSN.includes("sentry.io");

export const IS_GROWTHBOOK_ENABLED =
  (process.env.REACT_APP_GROWTHBOOK_ENABLED || false).toString() === "true";

export const oauth2Providers = {
  google: "google",
  linkedin: "linkedin",
  facebook: "facebook",
  apple: "apple",
};

export const HELP_FORM_TICKET_TYPE = {
  feedback: "feedback",
  custom_voice_request: "custom_voice_request",
  help: "help",
};

export const HELP_FORM_TOPICS_ENUMS = {
  AUDIO_QUALITY: "Audio quality",
  RECORDING: "Recording",
  CALIBRATION: "Calibration",
  ACCENTS: "Accents",
  VOICES: "Voices",
  ACCOUNT_PRICING: "Account & Pricing",
  REQUEST_CUSTOM_VOICE: "Request Custom Voice",
  OTHER: "Other",
};

export const HELP_FORM_TOPICS = [
  HELP_FORM_TOPICS_ENUMS.AUDIO_QUALITY,
  HELP_FORM_TOPICS_ENUMS.RECORDING,
  HELP_FORM_TOPICS_ENUMS.CALIBRATION,
  HELP_FORM_TOPICS_ENUMS.ACCENTS,
  HELP_FORM_TOPICS_ENUMS.VOICES,
  HELP_FORM_TOPICS_ENUMS.ACCOUNT_PRICING,
  HELP_FORM_TOPICS_ENUMS.REQUEST_CUSTOM_VOICE,
  HELP_FORM_TOPICS_ENUMS.OTHER,
];

export const VOICES_ENUMS = {
  species: {
    human: "human",
    animal: "animal",
    // fyi will be used in the future
    // other: "other",
  },
  age: {
    child: "child",
    young: "young",
    adult: "adult",
    senior: "senior",
  },
  gender: {
    male: "male",
    female: "female",
  },
  pitch: {
    low: "low",
    mid: "mid",
    high: "high",
  },
  category: {
    voice_talent: "Voice Talents",
    voice_library: "Voice Library",
  },
};

export const PROJECTS_ENUMS = {
  state: { active: "active", empty: "empty", deleted: "deleted" },
};

export const VOICE_VISIBILITY = {
  public: "public",
  paid: "paid",
  private: "private",
  kids: "kids",
  enterprise: "enterprise",
};

export const VOICE_VISIBILITY_LABELS = {
  public: "Marketplace",
  private: "Custom",
};

export const VOICE_NO_ACCENT = {
  key: "no_ac",
  label: "Yours",
};

export const VOICE_BALANCED = {
  key: "en_bl",
  label: "Balanced",
};

export const VOICE_NATIVE = {
  label: "Native",
};

export const ACCENT_SAMPLES_TYPES = {
  casual: "Casual",
  surprised: "Surprised",
  advertising: "Advertising",
  singing: "Singing",
};

export const NARRATION_STYLE_SAMPLES_TYPES = {
  default: "Default",
};

export const RECORDER_TABS = {
  microphone: "sts",
  file: "file",
  tts: "tts",
};

export const WS_ACTIONS = {
  USER_SESSION_END: "user.session_end",
  USER_UPDATED: "user.updated",
  CREDITS_UPDATED: "credits.updated2",
  CONVERSION_NOTIFICATION: "conversion.notification",
  CONVERSION_FINISHED: "conversion.finished",
  CONVERSION_PROCESSING: "conversion.processing",
  CALIBRATION_NOTIFICATION: "calibration.notification",
  CONTENT_MODERAIOTN_RESULT: "content_moderation.result",
};

export const SIDEBARS = {
  left: "left",
  right: "right",
};

export const NOTIFICATION_POSITIONS = {
  top: "top",
  bottom: "bottom",
  center: "center",
};

export const MIN_SEARCH_LENGTH = 2;
export const SEARCH_ITEMS_COUNT = 5;

export const CALIBRATION_AUTO = {
  id: "auto",
  label: "Auto",
};

export const NOTIFICATION_GROUPS = {
  general: "general",
  a11y: "a11y",
  consversionResult: "consversionResult",
};

export const LAST_USED_VOICES_COUNT = 10;

export const WELCOME_WIZARD_STEPS = {
  intro: "intro",
  profession: "profession",
  create: "create",
  proccesing: "proccesing",
  conversions: "conversions",
};

export const RECORDING_MODERATION_STATE = {
  processing: "processing",
  error: "error",
  done: "done",
  skip: "skip",
};

export const SYNTHETIC_DELAY = 300;

// ISO 639 language codes
export const LANGUAGE_CODES = {
  en: "en",
  fr: "fr",
  ab: "ab",
  aa: "aa",
  af: "af",
  ak: "ak",
  sq: "sq",
  am: "am",
  ar: "ar",
  an: "an",
  hy: "hy",
  as: "as",
  av: "av",
  ae: "ae",
  ay: "ay",
  az: "az",
  bm: "bm",
  ba: "ba",
  eu: "eu",
  be: "be",
  bn: "bn",
  bi: "bi",
  bs: "bs",
  br: "br",
  bg: "bg",
  my: "my",
  ca: "ca",
  km: "km",
  ch: "ch",
  ce: "ce",
  ny: "ny",
  zh: "zh",
  cu: "cu",
  cv: "cv",
  kw: "kw",
  co: "co",
  cr: "cr",
  hr: "hr",
  cs: "cs",
  da: "da",
  dv: "dv",
  nl: "nl",
  dz: "dz",
  eo: "eo",
  et: "et",
  ee: "ee",
  fo: "fo",
  fj: "fj",
  fi: "fi",
  ff: "ff",
  gd: "gd",
  gl: "gl",
  lg: "lg",
  ka: "ka",
  de: "de",
  el: "el",
  gn: "gn",
  gu: "gu",
  ht: "ht",
  ha: "ha",
  he: "he",
  hz: "hz",
  hi: "hi",
  ho: "ho",
  hu: "hu",
  is: "is",
  io: "io",
  ig: "ig",
  id: "id",
  ia: "ia",
  ie: "ie",
  iu: "iu",
  ik: "ik",
  ga: "ga",
  it: "it",
  ja: "ja",
  jv: "jv",
  kl: "kl",
  kn: "kn",
  kr: "kr",
  ks: "ks",
  kk: "kk",
  ki: "ki",
  rw: "rw",
  ky: "ky",
  kv: "kv",
  kg: "kg",
  ko: "ko",
  kj: "kj",
  ku: "ku",
  lo: "lo",
  la: "la",
  lv: "lv",
  li: "li",
  ln: "ln",
  lt: "lt",
  lu: "lu",
  lb: "lb",
  mk: "mk",
  mg: "mg",
  ms: "ms",
  ml: "ml",
  mt: "mt",
  gv: "gv",
  mi: "mi",
  mr: "mr",
  mh: "mh",
  mn: "mn",
  na: "na",
  nv: "nv",
  ng: "ng",
  ne: "ne",
  nd: "nd",
  se: "se",
  no: "no",
  nb: "nb",
  nn: "nn",
  oc: "oc",
  oj: "oj",
  or: "or",
  om: "om",
  os: "os",
  pi: "pi",
  ps: "ps",
  fa: "fa",
  pl: "pl",
  pt: "pt",
  "pt-br": "pt-br",
  pa: "pa",
  qu: "qu",
  ro: "ro",
  rm: "rm",
  rn: "rn",
  ru: "ru",
  sm: "sm",
  sg: "sg",
  sa: "sa",
  sc: "sc",
  sr: "sr",
  sn: "sn",
  ii: "ii",
  sd: "sd",
  si: "si",
  sk: "sk",
  sl: "sl",
  so: "so",
  nr: "nr",
  st: "st",
  es: "es",
  su: "su",
  sw: "sw",
  ss: "ss",
  sv: "sv",
  tl: "tl",
  ty: "ty",
  tg: "tg",
  ta: "ta",
  tt: "tt",
  te: "te",
  th: "th",
  bo: "bo",
  ti: "ti",
  to: "to",
  ts: "ts",
  tn: "tn",
  tr: "tr",
  tk: "tk",
  tw: "tw",
  ug: "ug",
  uk: "uk",
  ur: "ur",
  uz: "uz",
  ve: "ve",
  vi: "vi",
  vo: "vo",
  wa: "wa",
  cy: "cy",
  fy: "fy",
  wo: "wo",
  xh: "xh",
  yi: "yi",
  yo: "yo",
  za: "za",
  zu: "zu",
};

export const TTS_LANGUAGE_CODES = {
  en: "English",
  fr: "French",
  de: "German",
  ar: "Arabic",
  zh: "Chinese",
  cs: "Czech",
  da: "Danish",
  nl: "Dutch",
  tl: "Tagalog",
  el: "Greek",
  hi: "Hindi",
  hu: "Hungarian",
  id: "Indonesian",
  it: "Italian",
  ja: "Japanese",
  ko: "Korean",
  no: "Norwegian",
  pl: "Polish",
  pt: "Portuguese",
  "pt-br": "Portuguese Brazilian",
  ro: "Romanian",
  es: "Spanish",
  sv: "Swedish",
  th: "Thai",
  tr: "Turkish",
  uk: "Ukrainian",
  vi: "Vietnamese",
};

export const RESPEECHER_TTS_LANGUAGE_CODES = [
  LANGUAGE_CODES.en,
  LANGUAGE_CODES.fr,
  LANGUAGE_CODES.de,
];

export const ORIGINAL_TYPE = {
  tts: "tts",
  sts: "sts",
};

export const NARRATION_STYLE_BASIC = {
  id: "BASIC",
  is_default: true,
  tags: [{ name: "Basic" }],
  settings: {
    favorite: false,
  },
};

export const TTS_LANGUAGE_INFO_TEXT =
  "While English supports various narration styles through the Advanced Model, non-English languages are currently limited to the basic narration style offered by the Legacy Model.";

export const PLAYER_PLACES = {
  voiceCard: "voiceCard",
  welcomeWizard: "welcomeWizard",
};

export const CONVERSION_MAX_COUNT = 10;

export const GOOGLE_EVENT_NAMES = {
  explorer: "marketplace_subscribe_explorer_click",
  creator: "marketplace_subscribe_creator_click",
  power: "marketplace_subscribe_power_click",
  tts: "marketplace_subscribe_tts_only_click",
  contact: "marketplace_contact_us_click",
  credits: "marketplace_buy_credits_click",
};

export const PRO_TOOLS_PLUGIN_DOWNLOAD_LINK =
  "https://docs.respeecher.com/plugin";

export const VOICE_TALENT_CHARGE_TOOLTIP_TEXT =
  "Voice Talent voices can be more expensive than Voice Library voices.";
